import React, {Component} from "react";
import PropTypes from "prop-types";
import Invoices from "./Invoices.js";
import Payments from "./Payments.js";
import PayableSummary from "./PayableSummary.js";
import Ads from "./Ads";
import "./CustomerInfo.css";
import { LoadingStates, currentUserInfo } from "../App.js";

class CustomerInfo extends Component {

	constructor(props) {
		super(props);

		this.setPastDueInvoicesToPay = this.setPastDueInvoicesToPay.bind(this);
		this.setCurrentInvoicesToPay = this.setCurrentInvoicesToPay.bind(this);
		this.setPrepaidAdsToPay = this.setPrepaidAdsToPay.bind(this);
		this.setBilledAdsToPay = this.setBilledAdsToPay.bind(this);
		this.payNow = this.payNow.bind(this);

		var initialState = {
			previousInvoices: null,
			pastDueInvoices: null,
			currentInvoices: null,

			previousAds: null,
			prepaidAds: null,
			billedAds: null,

			pastDueInvoicesToPay: null,
			currentInvoicesToPay: null,
			prepaidAdsToPay: null,
			billedAdsToPay: null,

			pastDueInvoicePaymentTotal: null,
			currentInvoicePaymentTotal: null,
			prepaidAdPaymentTotal: null,
			billedAdPaymentTotal: null
		};

		if (props.defaultItemsToPay) {
			initialState.pastDueInvoicesToPay = props.defaultItemsToPay.pastDueInvoices;
			initialState.currentInvoicesToPay = props.defaultItemsToPay.currentInvoices;
			initialState.prepaidAdsToPay = props.defaultItemsToPay.prepaidAds;
			initialState.billedAdsToPay = props.defaultItemsToPay.billedAds;

			initialState.pastDueInvoicePaymentTotal =
					initialState.pastDueInvoicesToPay ? initialState.pastDueInvoicesToPay
						.reduce((total, inv) => total = total + inv.receivable, 0.00) : null;
			initialState.currentInvoicePaymentTotal =
					initialState.currentInvoicesToPay ? initialState.currentInvoicesToPay
						.reduce((total, inv) => total = total + inv.receivable, 0.00) : null;
			initialState.prepaidAdPaymentTotal =
					initialState.prepaidAdsToPay ? initialState.prepaidAdsToPay
						.reduce((total, ad) => total = total + ad.totalUnpaid, 0.00) : null;
			initialState.billedAdPaymentTotal =
					initialState.billedAdsToPay ? initialState.billedAdsToPay
						.reduce((total, ad) => total = total + ad.totalUnpaid, 0.00) : null;
		}

		//Invoices and ads are pulled out in getDerivedStateFromProps
		this.state = initialState;
	}

	setPastDueInvoicesToPay(invoices){
		let pastDueInvoicesToPay = invoices && invoices.length > 0 ? invoices : null;
		let total = pastDueInvoicesToPay ?
			pastDueInvoicesToPay.reduce((total, inv) => total = total+inv.receivable, 0) : null;
		this.setState({
			pastDueInvoicesToPay: pastDueInvoicesToPay,
			pastDueInvoicePaymentTotal: total
		});
	}

	setCurrentInvoicesToPay(invoices){
		let currentInvoicesToPay = invoices && invoices.length > 0 ? invoices : null;
		let total = currentInvoicesToPay ?
			currentInvoicesToPay.reduce((total, inv) => total = total+inv.receivable, 0) : null;
		this.setState({
			currentInvoicesToPay: currentInvoicesToPay,
			currentInvoicePaymentTotal: total
		});
	}

	setPrepaidAdsToPay(ads){
		let prepaidAdsToPay = ads && ads.length > 0 ? ads : null;
		let total = prepaidAdsToPay ?
			prepaidAdsToPay.reduce((total, ad) => total = total+ad.totalUnpaid, 0) : null;
		this.setState({
			prepaidAdsToPay: prepaidAdsToPay,
			prepaidAdPaymentTotal: total
		});
	}

	setBilledAdsToPay(ads){
		let billedAdsToPay = ads && ads.length > 0 ? ads : null;
		let total = billedAdsToPay ?
			billedAdsToPay.reduce((total, ad) => total = total+ad.totalUnpaid, 0) : null;
		this.setState({
			billedAdsToPay: billedAdsToPay,
			billedAdPaymentTotal: total
		});
	}

	payNow() {
		this.props.setItemsToPay({
			pastDueInvoices: this.state.pastDueInvoicesToPay,
			currentInvoices: this.state.currentInvoicesToPay,
			prepaidAds: this.state.prepaidAdsToPay,
			billedAds: this.state.billedAdsToPay
		});
		this.props.history.push("/pay");
	}

	//Derives the pastDue and current invoices from the invoice list.
	//Derives the prepaid and unbilled ads from the ads list.
	//Called before each call to `render`.
	static getDerivedStateFromProps(props, state) {
		var invoiceState = null;
		var adState = null;
		var newState = null;
		if (props.invoices !== state.previousInvoices) {
			let today = new Date();
			invoiceState = {
				previousInvoices: props.invoices,
				pastDueInvoices: props.invoices.filter(invoice => invoice.dueDate <= today),
				currentInvoices: props.invoices.filter(invoice => invoice.dueDate > today)
			};
		}
		if (props.ads !== state.previousAds) {
			let payableAds = props.ads.filter(ad => ad.totalUnpaid > 0);
			let prepaidAds = payableAds.filter(ad => !ad.billed);
			let billedAds = payableAds.filter(ad => ad.billed);
			adState = {
				previousAds: props.ads,
				prepaidAds: prepaidAds,
				billedAds: billedAds
			};
		}

		if (invoiceState) {
			newState = newState ?
				Object.assign(newState, invoiceState) :
				Object.assign(state, invoiceState);
		}
		if (adState) {
			newState = newState ?
				Object.assign(newState, adState) :
				Object.assign(state, adState);
		}
		return newState;
	}

	render() {
		let component = null;
		switch (this.props.loadingState) {
		case LoadingStates.inProgress:
			component = <Loading />;
			break;
		case LoadingStates.success:
			component =
				<div className="CustomerAccountInfo">
					<h2>{currentUserInfo.numberAndName()}</h2>
					<h2>Account Portal</h2>
					<Preamble />
					<PayableSummary
						loadingState={this.props.loadingState}
						currentInvoices={this.state.currentInvoices}
						pastDueInvoices={this.state.pastDueInvoices}
						prepaidAds={this.state.prepaidAds}
						unbilledAds={this.state.billedAds}
						payAction={this.payNow}
						pastDueInvoicePaymentTotal={this.state.pastDueInvoicePaymentTotal}
						currentInvoicePaymentTotal={this.state.currentInvoicePaymentTotal}
						prepaidAdPaymentTotal={this.state.prepaidAdPaymentTotal}
						billedAdPaymentTotal={this.state.billedAdPaymentTotal}
					/>
					<Invoices
						loadingState={this.props.loadingState}
						invoices={this.state.pastDueInvoices}
						description="Past Due Invoices"
						selectable={true}
						onSelectedItemsChanged={this.setPastDueInvoicesToPay}
						defaultSelectedItems={this.state.pastDueInvoicesToPay}
					/>
					<Ads
						loadingState={this.props.loadingState}
						ads={this.state.prepaidAds}
						description="Ads Requiring Prepayment"
						selectable={true}
						onSelectedItemsChanged={this.setPrepaidAdsToPay}
						defaultSelectedItems={this.state.prepaidAdsToPay}
					/>
					<Invoices
						loadingState={this.props.loadingState}
						invoices={this.state.currentInvoices}
						description="Current Invoices"
						selectable={true}
						onSelectedItemsChanged={this.setCurrentInvoicesToPay}
						defaultSelectedItems={this.state.currentInvoicesToPay}
					/>
					<Ads
						loadingState={this.props.loadingState}
						ads={this.state.billedAds}
						description="Ads Not Yet Invoiced"
						selectable={true}
						onSelectedItemsChanged={this.setBilledAdsToPay}
						defaultSelectedItems={this.state.billedAdsToPay}
					/>
					<Payments
						loadingState={this.props.loadingState}
						payments={this.props.payments}
						startDate={this.props.startDate}
					/>
				</div>;
			break;
		case LoadingStates.failed:
			component = <AccountInfoLoadFailure />;
			break;
		default:
			component = <h1>Programming Error: Unknown LoadingState {this.props.loadingState}</h1>;
		}
		return component;
	}
}

CustomerInfo.propTypes = {
	loadingState: PropTypes.number,
	invoices: PropTypes.array,
	payments: PropTypes.array,
	ads: PropTypes.array,
	startDate: PropTypes.instanceOf(Date),
	setItemsToPay: PropTypes.func.isRequired,
	defaultItemsToPay: PropTypes.object,
	history: PropTypes.object.isRequired
};

function Loading() {
	return (
		<div className="CustomerInfo-Loading">
			<h2>Loading Your Account Information</h2>
		</div>
	);
}

function AccountInfoLoadFailure() {
	return (
		<div className="Error">
			<h2>Unable to Load Your Account Information</h2>
			<p>You can re-try loading your account by reloading this page.</p>
			<p>If the problem persists, please call us at (484) 462-4300.</p>
		</div>
	);
}

function Preamble() {
	return (
		<div className="CustomerAccountInfo-Preamble">
			Below is a summary of transactions that are currently posted to your account.
			Note that this may not reflect all the charges you have incurred and payments
			you have made as of today.
		</div>
	);
}

export default CustomerInfo;



// WEBPACK FOOTER //
// ./src/components/CustomerInfo.js